<login-header></login-header>

<div class="gdpr-hero" style="background-image: url('../assets/images/gdpr-hero-bg.webp');">
    <div class="content-width text-center">
        <div class="gdpr-content">
            <img src="../assets/images/gdpr-circle.webp" alt="GDPR Image">
            <h1 class="mb-3">Family Central is GDPR ready.</h1>
            <p class="mb-3">General Data Protection Regulation, or GDPR, gives EU consumers the right to know, understand, and consent to the data companies that collect data about them was an EU legislative change that came into effect back in May 2018. GDPR aims to give control to citizens and residents by unifying the regulation within the EU.</p>
        </div>
    </div>
</div>

<app-footer (showPrice)="showPricing()"></app-footer>

<ng-template #pricing>
    <app-pricing (onCancel)="onClose()"></app-pricing>
</ng-template>